'use client'
import React, { useEffect } from 'react'
import { GA4Event } from './types'

type GTMData = Partial<GA4Event>

export const sendGA4Event = (event: string, data: GTMData) => {
    if (typeof window !== 'undefined' && window.dataLayer && Object.keys(data).length > 0) {
        window.dataLayer.push({ event, ...data })
    }
}

export const GoogleTagManager: React.FC<{ event: string; gtmData: GTMData }> = ({ event, gtmData }) => {
    useEffect(() => {
        if (typeof window !== 'undefined' && window.dataLayer && Object.keys(gtmData).length > 0) {
            window.dataLayer.push({ event, ...gtmData })
        }
    }, [event, gtmData])

    return null
}
